import { createBrowserRouter, Navigate } from "react-router"
import { auditRoutes } from "./pages/audit/routes"
import { clientsRoutes } from "./pages/clients/routes"
import { dashboardRoutes } from "./pages/dashboard/routes"
import { domainsRoutes } from "./pages/domains/routes"
import { loginRoutes } from "./pages/login/routes"
import { nodesRoutes } from "./pages/nodes/routes"
import { profileRoutes } from "./pages/profile/routes"
import { rolesRoutes } from "./pages/roles/routes"
import { scopesRoutes } from "./pages/scopes/routes"
import { settingsRoutes } from "./pages/settings/routes"
import { usersRoutes } from "./pages/users/routes"
import { AppShell } from "./shell/app-shell"
import { RequireAuth } from "./shell/require-auth"

// Router de la consola — docs/05 §6. Cada módulo es dueño de su carpeta en
// pages/* y aporta sus RouteObject; aquí solo se componen.
export const router = createBrowserRouter([
  ...loginRoutes,
  {
    path: "/",
    element: (
      <RequireAuth>
        <AppShell />
      </RequireAuth>
    ),
    children: [
      ...dashboardRoutes,
      ...usersRoutes,
      ...domainsRoutes,
      ...rolesRoutes,
      ...scopesRoutes,
      ...nodesRoutes,
      ...clientsRoutes,
      ...auditRoutes,
      ...settingsRoutes,
      ...profileRoutes,
      { path: "*", element: <Navigate to="/" replace /> },
    ],
  },
])
